export default {
    ws: {},
    setWs: function(newWs) {
        this.ws = newWs;
    },
    count: 0,
    timerN: null,

}